import { useEffect, useRef } from 'react';

const useEffectOnce = ({ effect, dependencies, condition = true }) => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;

    if (condition) {
      hasRun.current = true;

      effect();
    }
  }, dependencies);
};

export default useEffectOnce;
